jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.staff-members').length ) {
        let $ = jQuery;

        $('.staff-members .staff-grid .single-staff-member a.name').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            let $popup = $(this).parent().parent().parent().find('.staff-member-popup');

            let $name = $(this).parent().find('.name').html();
            let $role = $(this).parent().find('.role').html();
            let $email = $(this).parent().find('.email').html();
            let $content = $(this).parent().find('.popup-content').html();
            $popup.find('.name').html($name);
            $popup.find('.role').html($role);
            $popup.find('.email').html($email);
            $popup.find('.popup-content').html($content);
            $popup.show();
        });
        $('.staff-members .staff-grid .single-staff-member.toggle-popup').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            let $popup = $(this).parent().parent().find('.staff-member-popup');

            let $name = $(this).find('.name').html();
            let $role = $(this).find('.role').html();
            let $email = $(this).find('.email').html();
            let $content = $(this).find('.popup-content').html();
            $popup.find('.name').html($name);
            $popup.find('.role').html($role);
            $popup.find('.email').html($email);
            $popup.find('.popup-content').html($content);
            $popup.show();
        });
        $('.staff-members .staff-member-popup .close').on('click', function (e) {
            $('.staff-members .staff-member-popup').fadeOut();

        });

    }
});